import { c as _c } from "react/compiler-runtime";
import { Dropdown } from '@common/components';
import { SvgKebab } from '@common/icon';
interface ReviewCardMenuProps {
  onEdit: () => void;
  onDelete?: () => void;
}
export const ReviewCardMenu = t0 => {
  const $ = _c(8);
  const {
    onEdit,
    onDelete
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Dropdown.Trigger asChild={true}><button type="button" aria-label={"\uC635\uC158"} className="-m-16 p-16"><SvgKebab className="size-16" /></button></Dropdown.Trigger>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onEdit) {
    t2 = <Dropdown.Item className="px-16 py-8 font-400 text-Gray-900 transition-all duration-300 typo-body3 hover:bg-Gray-100" role="button" aria-label={"\uC218\uC815"} onClick={e => {
      e.stopPropagation();
      onEdit();
    }}>수정</Dropdown.Item>;
    $[1] = onEdit;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onDelete) {
    t3 = onDelete && <Dropdown.Item className="px-16 py-8 font-400 text-R-500 transition-all duration-300 typo-body3 hover:bg-Gray-100" role="button" aria-label={"\uC0AD\uC81C"} onClick={e_0 => {
      e_0.stopPropagation();
      onDelete();
    }}>삭제</Dropdown.Item>;
    $[3] = onDelete;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Dropdown.Root dir="rtl">{t1}<Dropdown.Content className="z-10 mt-4 min-w-150 rounded-xsmall bg-Gray-white shadow-xl">{t2}{t3}</Dropdown.Content></Dropdown.Root>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};